<template>
  <div>
    <section class="">
      <div class="level-item">
        <img src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/Intellitots-logo.png" />
      </div>
      <br />

      <div class="level-item">
        <p class="title is-2">Admission Form</p>
      </div>
    </section>
    <section class="container section page-header section is-main-section">
      <form class="container" name="admission" @submit.prevent="saveAdmission">
        <div class="container">
          <AdmissionElement formType="createAdmission" :isWritable="this.message" v-model="studentData" showAdmissionDate="false" />
        </div>
        <div class="container">
          <RegStudentElement :formType="this.typeForm" :isWritable="this.message" v-model="parentdata" />
        </div>
        <div class="container">
          <RegParentElement :formType="this.typeForm" :isWritable="this.message" parentType="father" v-model="studentData" :pointOfContact="parentdata.pointOfContact" />
        </div>
        <div class="container">
          <RegParentElement :formType="this.typeForm" :isWritable="this.message" parentType="mother" v-model="studentData" :pointOfContact="parentdata.pointOfContact" />
        </div>
        <div class="container">
          <AddressElement :formType="this.typeForm" :isWritable="this.message" v-model="studentData" />
        </div>
        <div class="container">
          <OtherElement :formType="this.typeForm" :isWritable="this.message" v-model="parentdata" />
        </div>
        <div class="container">
          <SiblingElement :formType="this.typeForm" :isWritable="this.message" v-model="admissionData" />
        </div>
        <div class="container">
          <HealthElement :formType="this.typeForm" :isWritable="this.message" v-model="admissionData" />
        </div>
        <div class="container" v-if="this.isLoaded === 'true'">
          <RegDocumentElement :formType="this.typeForm" :isWritable="this.message" v-model="admissionData" :enquiryID="parentdata.id" :franchiseeID="parentdata.franchisee.id" />
        </div>

        <div class="container">
          <IAgreeCheckbox v-model="admissionData" />
        </div>

        <footer class="column has-text-right" v-if="this.refID">
          <button class="button is-success" type="submit" :disabled="hasClicked">
            Save
          </button>
        </footer>
      </form>
    </section>
  </div>
</template>

<script>
import constants from '@/utils/constants'
import RegStudentElement from '@/components/Forms/Elements/RegStudentElement'
import RegParentElement from '@/components/Forms/Elements/RegParentElement'
import OtherElement from '@/components/Forms/Elements/OtherElement'
import AddressElement from '@/components/Forms/Elements/AddressElement'
import HealthElement from '@/components/Forms/Elements/HealthElement'
import RegDocumentElement from '@/components/Forms/Elements/RegDocs'
import SiblingElement from '@/components/Forms/Elements/SiblingElement'
import AdmissionElement from '@/components/Forms/Elements/AdmissionElement'
import IAgreeCheckbox from '@/components/Forms/Elements/IAgreeCheckbox'
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'admissionFormOffline',
  props: ['refID'],
  components: {
    RegStudentElement,
    RegParentElement,
    OtherElement,
    AddressElement,
    HealthElement,
    RegDocumentElement,
    SiblingElement,
    IAgreeCheckbox,
    AdmissionElement
  },
  data: function () {
    return {
      checkboxGroup: ['SMS', 'Email'],
      enquiry: {},
      academicYears: [],
      parentdata: {},
      studentData: {},
      admissionData: {},
      data: [],
      hasClicked: false,
      loader: true,
      formData: {},
      message: 'true',
      typeForm: 'admission',
      registrationID: '',
      enquiryCode: '',
      isLoaded: 'false',
      enquiryID: ''
    }
  },
  async created () {
    await this.onstart()
    await this.writable()
  },
  async mounted () {
    await this.onstart()
    await this.writable()
  },
  methods: {
    writable: async function () {
      if (this.isLoaded === 'true') {
        this.message = 'false'
        this.typeForm = 'admission'
      }
    },

    saveAdmission: async function () {
      try {
        this.hasClicked = true
        this.loader = true
        this.parentdata.enquiry = ''
        this.loadingComponent = this.$buefy.loading.open()
        if (this.parentdata.pointOfContact === 'MOTHER') {
          if (_.isEmpty(this.studentData.motherName) || _.isEmpty(this.studentData.motherEmailID) || _.isEmpty(this.studentData.motherMobile)) {
            this.loadingComponent.close()

            this.lock = false
            this.hasClicked = false
            return this.$buefy.dialog.alert({
              message: 'Please fill mother details as you have selected Mother as point of contact',
              type: 'is-danger',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',
              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        }
        let inputData = {
          motherTongue: this.parentdata.motherTongue,
          exposureToEnglishLanguage: this.parentdata.exposureToEnglishLanguage,
          identificationMarks: this.parentdata.identificationMarks,
          franchiseeID: this.parentdata.franchisee.id,
          academicYearID: this.studentData.academicYearID,
          studentFirstName: this.parentdata.studentFirstName,
          studentMiddleName: this.parentdata.studentMiddleName,
          studentLastName: this.parentdata.studentLastName,
          fatherName: this.studentData.fatherName,
          fatherMobile: this.studentData.fatherMobile,
          fatherEmail: this.studentData.fatherEmailID,
          fatherOccupation: this.studentData.fatherOccupation,
          motherName: this.studentData.motherName,
          motherEmailID: this.studentData.motherEmailID,
          motherMobile: this.studentData.motherMobile,
          motherOccupation: this.studentData.motherOccupation,
          address1: this.studentData.address1,
          address: this.studentData.address1,
          pincode: this.parentdata.pincode,
          countryName: this.studentData.countryName,
          state: this.studentData.state,
          city: this.studentData.city,
          locality: this.studentData.locality,
          dateOfBirth: this.parentdata.dateOfBirth,
          placeOfBirth: this.parentdata.placeOfBirth,
          gender: this.parentdata.gender,
          pointOfContact: this.parentdata.pointOfContact,
          guardianName: this.studentData.guardianName,
          guardianMobile: this.studentData.guardianMobile,
          guardianEmailID: this.studentData.guardianEmailID,
          fatherDesignation: this.studentData.fatherDesignation,
          fatherQualification: this.studentData.fatherQualification,
          fatherOrganisation: this.studentData.fatherOrganisation,
          fatherOfficePhoneNo: this.studentData.fatherOfficePhoneNo,
          fatherOfficeAddress: this.studentData.fatherOfficeAddress,
          motherQualification: this.studentData.motherQualification,
          motherOrganisation: this.studentData.motherOrganisation,
          motherOfficePhoneNo: this.studentData.motherOfficePhoneNo,
          motherOfficeAddress: this.studentData.motherOfficeAddress,
          motherDesignation: this.studentData.motherDesignation,
          emergencyContactDetails: this.admissionData.emergencyContactDetails,
          siblingName: this.admissionData.siblingName,
          siblingAge: this.admissionData.siblingAge,
          siblingClass: this.admissionData.siblingClass,
          siblingSchool: this.admissionData.siblingSchool,
          siblingOtherSchool: this.admissionData.siblingOtherSchool,
          referralsChildName: this.admissionData.referralsChildName,
          referralsChildAge: this.admissionData.referralsChildAge,
          referralsFatherMotherName: this.admissionData.referralsFatherMotherName,
          referralsFatherMotherMobileNo: this.admissionData.referralsFatherMotherMobileNo,
          referralsRelation: this.admissionData.referralsRelation,
          bloodGroup: this.admissionData.bloodGroup,
          anySeriousAccidentsOrIllnessOrOperarions: this.admissionData.anySeriousAccidentsOrIllnessOrOperarions,
          dateForSeriousAccidentsOrIllnessOrOperarions: this.admissionData.dateForSeriousAccidentsOrIllnessOrOperarions,
          allergiesOrAsthmaOrBreathlessness: this.admissionData.allergiesOrAsthmaOrBreathlessness,
          anyOtherAliment: this.admissionData.anyOtherAliment,
          specialCare: this.admissionData.specialCare,
          foodAllergies: this.admissionData.foodAllergies,
          drugAllergies: this.admissionData.drugAllergies,
          anyPhysicalChallengeOrLearningDifficulties: this.admissionData.anyPhysicalChallengeOrLearningDifficulties,
          prescribedMedication: this.admissionData.prescribedMedication,
          techniqueToDisciplineYourChild: this.admissionData.techniqueToDisciplineYourChild,
          childsUsualReactionToBeingDisciplined: this.admissionData.childsUsualReactionToBeingDisciplined,
          childsReactionForNewSituation: this.admissionData.childsReactionForNewSituation,
          isNewPeopleEasilyAcceptable: this.admissionData.isNewPeopleEasilyAcceptable,
          familyDoctorOrPhysicianName: this.admissionData.familyDoctorOrPhysicianName,
          familyDoctorOrPhysicianQualification: this.admissionData.familyDoctorOrPhysicianQualification,
          practicingClinicDetails: this.admissionData.practicingClinicDetails,
          practicingClinicOfficeTelephone: this.admissionData.practicingClinicOfficeTelephone,
          practicingClinicMobileNo: this.admissionData.practicingClinicMobileNo,
          practicingClinicEmailID: this.admissionData.practicingClinicEmailID,
          chikenpoxVaricellaVaccineDate: this.admissionData.chikenpoxVaricellaVaccineDate,
          diptheriaDTapVaccineDate: this.admissionData.diptheriaDTapVaccineDate,
          haemophilusInfluenzaTypeBHiBVaccineDate: this.admissionData.haemophilusInfluenzaTypeBHiBVaccineDate,
          hepatitisAHepAVaccineDate: this.admissionData.hepatitisAHepAVaccineDate,
          hepatitisBHepBVaccineDate: this.admissionData.hepatitisBHepBVaccineDate,
          tetanusDTapDate: this.admissionData.tetanusDTapDate,
          studentPhotoUrl: !_.isEmpty(this.admissionData.studentPhotoUrl) ? this.admissionData.studentPhotoUrl : '',
          fatherPhotoUrl: !_.isEmpty(this.admissionData.fatherPhotoUrl) ? this.admissionData.fatherPhotoUrl : '',
          motherPhotoUrl: !_.isEmpty(this.admissionData.motherPhotoUrl) ? this.admissionData.motherPhotoUrl : '',
          birthCertificateUrl: !_.isEmpty(this.admissionData.birthCertificateUrl) ? this.admissionData.birthCertificateUrl : '',
          transferCertificateUrl: !_.isEmpty(this.admissionData.transferCertificateUrl) ? this.admissionData.transferCertificateUrl : '',
          immunisationCertificateUrl: !_.isEmpty(this.admissionData.immunisationCertificateUrl) ? this.admissionData.immunisationCertificateUrl : '',
          studentAadharCardUrl: !_.isEmpty(this.admissionData.studentAadharCardUrl) ? this.admissionData.studentAadharCardUrl : '',
          fatherAadharCardUrl: !_.isEmpty(this.admissionData.fatherAadharCardUrl) ? this.admissionData.fatherAadharCardUrl : '',
          motherAadharCardUrl: !_.isEmpty(this.admissionData.motherAadharCardUrl) ? this.admissionData.motherAadharCardUrl : '',
          healthCertificateUrl: !_.isEmpty(this.admissionData.healthCertificateUrl) ? this.admissionData.healthCertificateUrl : '',
          studentPhoto: this.admissionData.studentPhoto,
          fatherPhoto: this.admissionData.fatherPhoto,
          motherPhoto: this.admissionData.motherPhoto,
          birthCertificate: this.admissionData.birthCertificate,
          transferCertificate: this.admissionData.transferCertificate,
          immunisationCertificate: this.admissionData.immunisationCertificate,
          studentAadharCard: this.admissionData.studentAadharCard,
          fatherAadharCard: this.admissionData.fatherAadharCard,
          motherAadharCard: this.admissionData.motherAadharCard,
          healthCertificate: this.admissionData.healthCertificate,
          registrationCode: this.admissionData.registrationCode,
          enquiryCode: this.studentData.enquiryCode,
          iAgreeCheckbox: this.admissionData.iAgreeCheckbox
        }

        const formData = new FormData()
        for (var key in inputData) {
          if (typeof inputData[key] === 'undefined' || inputData[key] === null) {
            inputData[key] = ''
          }
          formData.append(key, inputData[key])
        }

        await http.put(`${constants.API_URL}/api/edit-admission/${this.refID}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        this.loader = false
        this.$router.push({ name: 'OfflinePayments', params: { referenceID: this.refID } })

        // let route = this.$router.resolve({ name: 'OfflinePayments', params: { referenceID: this.refID } })
        // // let route = this.$router.resolve('/link/to/page'); // This also works.
        // window.open(route.href, '_blank')
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Record saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While updating admission Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    onstart: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/admission/getReferenceDetails/${this.refID}`)
        let getRefDetails = data

        if (!_.isEmpty(getRefDetails)) {
          this.parentdata = data
          if (!_.isEmpty(this.parentdata.enquiryRegistrations)) {
            let admissionData = this.parentdata.enquiryRegistrations
            this.admissionData = admissionData[0]
            this.isRegistered = true
          }
          this.studentData = this.parentdata
          this.studentData.address = this.parentdata.address1
          this.parentdata.studentFirstName = this.parentdata.studentFirstName
          this.parentdata.studentLastName = this.parentdata.studentLastName
          this.parentdata.studentMiddleName = this.parentdata.studentMiddleName
          this.parentdata.gender = _.startCase(_.toLower(this.parentdata.gender))
          this.parentdata.exposureToEnglishLanguage = !_.isEmpty(this.admissionData.exposureToEnglishLanguage) ? this.admissionData.exposureToEnglishLanguage : ''
          this.parentdata.motherTongue = !_.isEmpty(this.admissionData.motherTongue) ? this.admissionData.motherTongue : ''
          this.parentdata.identificationMarks = !_.isEmpty(this.admissionData.identificationMarks) ? this.admissionData.identificationMarks : ''
          this.parentdata.emergencyContactDetails = !_.isEmpty(this.admissionData.emergencyContactDetails) ? this.admissionData.emergencyContactDetails : ''
          this.parentdata.fatherDesignation = !_.isEmpty(this.admissionData.fatherDesignation) ? this.admissionData.fatherDesignation : ''
          this.parentdata.fatherQualification = !_.isEmpty(this.admissionData.fatherQualification) ? this.admissionData.fatherQualification : ''
          this.parentdata.fatherOrganisation = !_.isEmpty(this.admissionData.fatherOrganisation) ? this.admissionData.fatherOrganisation : ''
          this.parentdata.fatherOfficePhoneNo = !_.isEmpty(this.admissionData.fatherOfficePhoneNo) ? this.admissionData.fatherOfficePhoneNo : ''
          this.parentdata.fatherOfficeAddress =
            !_.isEmpty(this.admissionData.fatherOfficeAddress) && this.admissionData.fatherOfficeAddress !== 'undefined' ? this.admissionData.fatherOfficeAddress : ''
          this.parentdata.motherDesignation = !_.isEmpty(this.admissionData.motherDesignation) && this.admissionData.motherDesignation !== 'undefined' ? this.admissionData.motherDesignation : ''
          this.parentdata.motherQualification =
            !_.isEmpty(this.admissionData.motherQualification) && this.admissionData.motherQualification !== 'undefined' ? this.admissionData.motherQualification : ''
          this.parentdata.motherOrganisation = !_.isEmpty(this.admissionData.motherOrganisation) && this.admissionData.motherOrganisation !== 'undefined' ? this.admissionData.motherOrganisation : ''
          this.parentdata.motherOfficePhoneNo =
            !_.isEmpty(this.admissionData.motherOfficePhoneNo) && this.admissionData.motherOfficePhoneNo !== 'undefined' ? this.admissionData.motherOfficePhoneNo : ''
          this.parentdata.motherOfficeAddress =
            !_.isEmpty(this.admissionData.motherOfficeAddress) && this.admissionData.motherOfficeAddress !== 'undefined' ? this.admissionData.motherOfficeAddress : ''
          this.parentdata.emergencyContactDetails =
            !_.isEmpty(this.admissionData.emergencyContactDetails) && this.admissionData.emergencyContactDetails !== 'undefined' ? this.admissionData.emergencyContactDetails : ''
          this.parentdata.siblingName =
            !_.isEmpty(this.admissionData.siblingName) && this.admissionData.siblingName !== 'undefined' && this.admissionData.siblingName !== null ? this.admissionData.siblingName : ''
          this.parentdata.siblingAge = !_.isEmpty(this.admissionData.siblingAge) && this.admissionData.siblingAge !== 'undefined' ? this.admissionData.siblingAge : ''
          this.parentdata.siblingClass = !_.isEmpty(this.admissionData.siblingClass) && this.admissionData.siblingClass !== 'undefined' ? this.admissionData.siblingClass : ''
          this.parentdata.siblingSchool = !_.isEmpty(this.admissionData.siblingSchool) && this.admissionData.siblingSchool !== 'undefined' ? this.admissionData.siblingSchool : ''
          this.parentdata.referralsChildName = !_.isEmpty(this.admissionData.referralsChildName) && this.admissionData.referralsChildName !== 'undefined' ? this.admissionData.referralsChildName : ''
          this.parentdata.referralsChildAge = !_.isEmpty(this.admissionData.referralsChildAge) && this.admissionData.referralsChildAge !== 'undefined' ? this.admissionData.referralsChildAge : ''
          this.parentdata.referralsFatherMotherName =
            !_.isEmpty(this.admissionData.referralsFatherMotherName) && this.admissionData.referralsFatherMotherName !== 'undefined' ? this.admissionData.referralsFatherMotherName : ''
          this.parentdata.referralsFatherMotherMobileNo =
            !_.isEmpty(this.admissionData.referralsFatherMotherMobileNo) && this.admissionData.referralsFatherMotherMobileNo !== 'undefined' ? this.admissionData.referralsFatherMotherMobileNo : ''
          this.parentdata.referralsRelation = !_.isEmpty(this.admissionData.referralsRelation) && this.admissionData.referralsRelation !== 'undefined' ? this.admissionData.referralsRelation : ''
          this.parentdata.childsReactionForNewSituation =
            !_.isEmpty(this.admissionData.childsReactionForNewSituation) && this.admissionData.childsReactionForNewSituation !== 'undefined' ? this.admissionData.childsReactionForNewSituation : ''
          this.parentdata.placeOfBirth = !_.isEmpty(this.admissionData.placeOfBirth) && this.admissionData.placeOfBirth !== 'undefined' ? this.admissionData.placeOfBirth : ''
          this.parentdata.siblingOtherSchool = !_.isEmpty(this.admissionData.siblingOtherSchool) && this.admissionData.siblingOtherSchool !== 'undefined' ? this.admissionData.siblingOtherSchool : ''
          this.parentdata.emergencyContactDetails =
            !_.isEmpty(this.admissionData.emergencyContactDetails) && this.admissionData.emergencyContactDetails !== 'undefined' ? this.admissionData.emergencyContactDetails : ''

          this.admissionData.franchiseeID = this.parentdata.franchisee.id
          this.admissionData.dateForSeriousAccidentsOrIllnessOrOperarions = !_.isEmpty(this.admissionData.dateForSeriousAccidentsOrIllnessOrOperarions)
            ? moment(this.admissionData.dateForSeriousAccidentsOrIllnessOrOperarions).format('YYYY-MM-DD')
            : ''
          this.admissionData.chikenpoxVaricellaVaccineDate = !_.isEmpty(this.admissionData.chikenpoxVaricellaVaccineDate)
            ? moment(this.admissionData.chikenpoxVaricellaVaccineDate).format('YYYY-MM-DD')
            : ''
          this.admissionData.haemophilusInfluenzaTypeBHiBVaccineDate = !_.isEmpty(this.admissionData.haemophilusInfluenzaTypeBHiBVaccineDate)
            ? moment(this.admissionData.haemophilusInfluenzaTypeBHiBVaccineDate).format('YYYY-MM-DD')
            : ''
          this.admissionData.hepatitisAHepAVaccineDate = !_.isEmpty(this.admissionData.hepatitisAHepAVaccineDate) ? moment(this.admissionData.hepatitisAHepAVaccineDate).format('YYYY-MM-DD') : ''
          this.admissionData.hepatitisBHepBVaccineDate = !_.isEmpty(this.admissionData.hepatitisBHepBVaccineDate) ? moment(this.admissionData.hepatitisBHepBVaccineDate).format('YYYY-MM-DD') : ''
          this.admissionData.tetanusDTapDate = !_.isEmpty(this.admissionData.tetanusDTapDate) ? moment(this.admissionData.tetanusDTapDate).format('YYYY-MM-DD') : ''
          this.admissionData.diptheriaDTapVaccineDate = !_.isEmpty(this.admissionData.diptheriaDTapVaccineDate) ? moment(this.admissionData.diptheriaDTapVaccineDate).format('YYYY-MM-DD') : ''
          this.parentdata.dateOfBirth = !_.isEmpty(this.admissionData.dateOfBirth) ? moment(this.parentdata.dateOfBirth).format('YYYY-MM-DD') : ''
          this.parentdata.placeOfBirth = !_.isEmpty(this.admissionData.placeOfBirth) && this.admissionData.placeOfBirth !== 'undefined' ? this.admissionData.placeOfBirth : ''
          this.admissionData.enquiryID = this.enquiryID
          this.admissionData.enquiryCode = this.parentdata.enquiryCode
          this.admissionData.iAgreeCheckbox = false
          //   this.parentdata.motherName = !_.isEmpty(this.admissionData.motherName) && (this.admissionData.motherName !== 'undefined') ? this.admissionData.motherName : ''
          //   this.parentdata.motherOccupation = !_.isEmpty(this.admissionData.motherOccupation) ? this.admissionData.motherOccupation : ''
          this.parentdata.franchiseeName = this.parentdata.franchisee.companyName
          this.parentdata.className = this.parentdata.studentClass.name
          this.parentdata.sectionName = this.parentdata.studentSection.name
          this.parentdata.academicYrName = this.parentdata.franchiseeAcademicYear.academicYear

          this.isLoaded = 'true'
        } else {
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: 'Invalid Link..',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    }
  }
}
</script>
